import { useMemo } from "react";

export default function useAgentTranscription(messages) {
  const {
    assistantTranscriptions,
    humanAgentTranscriptions,
    isCallTransfered,
  } = useMemo(() => {
    return messages.reduce(
      (acc, message) => {
        const { callTransferCheckpoint = false } = message;

        if (callTransferCheckpoint || acc.isCallTransfered) {
          acc.isCallTransfered = true;
          acc.humanAgentTranscriptions.push(message);

          return acc;
        }

        acc.assistantTranscriptions.push(message);
        return acc;
      },
      {
        isCallTransfered: false,
        assistantTranscriptions: [],
        humanAgentTranscriptions: [],
      }
    );
  }, [messages]);

  return {
    assistantTranscriptions,
    humanAgentTranscriptions,
    isCallTransfered,
  };
}
